import { EnvironmentTemplate } from './environment-template';
export const getEnvironment = function () {
	return EnvironmentTemplate.staticEnvironment;
};
